export const clobber = (state, update) =>
    Object
        .keys(update)
        .filter((key) => state.hasOwnProperty(key))
        .forEach((key) => { state[key] = update[key]; });

export const mapSetter = (setter, shape) => (state, { key, item }) => {
    if (!state.hasOwnProperty(key)) {
        setter.set(state, key, shape(key));
    }
    clobber(state[key], item);
};

export const keyedMapSetter = (setter, keyName, shape) => (state, item) => {
    const key = item[keyName];
    return mapSetter(setter, shape)(state, {
        key,
        item,
    });
};

export const mapProp = () => (state, { key, item }) => {
    clobber(state[key], item);
};

export const mapDeleter = (deleter) => (state, key) => deleter.delete(state, key);

export const mapPicker = (shape) => (state) => (key) => state[key] || shape(key);

export const mapClear = (deleter) => (state) => {
    Object.keys(state).forEach((key) => {
        deleter.delete(state, key);
    });
};

export const mapAllValues = (filterFn) => function(state) {
    return filterFn ? Object.values(state).filter(filterFn) : Object.values(state);
};
